import React from "react";

/**
 * Events — upcoming community events section.
 * Now receives events from the API via props (editable from admin).
 *
 * Props:
 *   events — array of { id, icon, title, description, day, time }
 */
function Events({ events }) {
  return (
    <section className="events-section py-5">
      <div className="container">
        <h2 className="text-center mb-2" style={{ color: "#d4af37" }}>
          Arrangementer
        </h2>
        <p className="text-center text-muted mb-5">
          Kommende aktiviteter og samlinger i Al-Yasin
        </p>

        {events.length === 0 && (
          <p className="text-center text-muted">Ingen arrangementer ennå.</p>
        )}

        <div className="row g-4 justify-content-center">
          {events.map((event) => (
            <div key={event.id} className="col-md-6 col-lg-4">
              <div className="event-card shadow rounded-4 p-4 h-100 d-flex flex-column">
                <div className="event-icon mb-3">{event.icon}</div>
                <h5 className="fw-bold">{event.title}</h5>
                <p className="text-muted flex-grow-1">{event.description}</p>
                <div className="event-meta mt-auto pt-3 border-top">
                  <small className="d-block text-dark fw-semibold">
                    📅 {event.day}
                  </small>
                  <small className="text-muted">🕐 {event.time}</small>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Events;
